export default __webpack_public_path__ + "static/media/Map.e805912d.png";